export default __webpack_public_path__ + "static/media/actividad-37.451f13f5.mp3";